import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import styled from 'styled-components';

import { Row, Column } from 'components/shared/Layout';
import InboundJourneySearchDate from 'components/shared/JourneySearchDate/InboundJourneySearchDate';
import OutboundJourneySearchDate from 'components/shared/JourneySearchDate/OutboundJourneySearchDate';
import { StyledText } from './JourneySearchHeader.styles';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

const ResponsiveRow = styled(Row)`
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

const ResponsiveColumn = styled(Column)``;

const JourneySearchHeader = ({
  booking = {},
  inbound,
  outbound,
  swapStations,
  cheapestFares,
  currency,
  subscriptionStartDate,
  subscriptionEndDate,
  isExchangingSingleOutboundLegOfSNCBSummated = false,
  isExchangingSingleInboundLegOfSNCBSummated = false
}) => (
  <>
    <ResponsiveRow>
      {outbound && (
        <ResponsiveColumn span={inbound ? 8 : 12}>
          <StyledText id="outbound-table-header">
            <OutboundJourneySearchDate
              booking={outbound && !inbound ? booking : null}
              isReturnJourney={!!outbound && !!inbound}
              cheapestFares={cheapestFares?.[0]}
              currency={currency}
              subscriptionStartDate={subscriptionStartDate}
              subscriptionEndDate={subscriptionEndDate}
              leg={booking.outbound}
              isExchangingSingleLegOfSNCBSummated={isExchangingSingleOutboundLegOfSNCBSummated}
            />
            <StyledText bold>
              <FormattedMessage id="searchResults.outbound.on" />
            </StyledText>
            {` ${moment(outbound.date, 'YYYY-MM-DD').format('dddd D MMMM YYYY')} — ${
              swapStations ? outbound.destination : outbound.origin
            } `}
            <StyledText bold>
              <FormattedMessage id="searchResults.to" />
            </StyledText>
            {` ${swapStations ? outbound.origin : outbound.destination} `}
          </StyledText>
        </ResponsiveColumn>
      )}

      {inbound && (
        <ResponsiveColumn span={outbound ? 8 : 12}>
          <StyledText id="inbound-table-header">
            <InboundJourneySearchDate
              booking={booking}
              isReturnJourney={!!outbound && !!inbound}
              cheapestFares={cheapestFares?.[1]}
              currency={currency}
              subscriptionStartDate={subscriptionStartDate}
              subscriptionEndDate={subscriptionEndDate}
              leg={booking.inbound}
              isExchangingSingleLegOfSNCBSummated={isExchangingSingleInboundLegOfSNCBSummated}
            />
            <StyledText bold>
              <FormattedMessage id="searchResults.inbound.on" />
            </StyledText>
            {` ${moment(inbound.date, 'YYYY-MM-DD').format('dddd D MMMM YYYY')} - ${swapStations ? inbound.destination : inbound.origin} `}
            <StyledText bold>
              <FormattedMessage id="searchResults.to" />
            </StyledText>
            {` ${swapStations ? inbound.origin : inbound.destination}`}
          </StyledText>
        </ResponsiveColumn>
      )}
    </ResponsiveRow>
  </>
);
JourneySearchHeader.propTypes = {
  booking: PropTypes.object,
  inbound: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    date: PropTypes.string
  }),
  outbound: PropTypes.shape({
    origin: PropTypes.string,
    destination: PropTypes.string,
    date: PropTypes.string
  }),
  cheapestFares: PropTypes.arrayOf(
    PropTypes.shape({
      cheapestFares: PropTypes.arrayOf(
        PropTypes.shape({
          date: PropTypes.string,
          price: PropTypes.number
        })
      )
    })
  ),
  swapStations: PropTypes.bool,
  currency: PropTypes.string,
  subscriptionStartDate: PropTypes.string,
  subscriptionEndDate: PropTypes.string,
  isExchangingSingleOutboundLegOfSNCBSummated: PropTypes.bool,
  isExchangingSingleInboundLegOfSNCBSummated: PropTypes.bool
};
export default JourneySearchHeader;
